import { useDispatch, useSelector } from "react-redux";
import { downloadReport } from "../thunks/downloadWeeklyDateReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useWeeklyReportDownloaderDate = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.weeklyTrade.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(() => dispatch(downloadReport()), [
    dispatch,
  ]);

  return [download, fetchState] as [typeof download, typeof fetchState];
};
